import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const comboboxOptionsFn = /* @__PURE__ */ createRecipe('combobox-options', {}, [])

const comboboxOptionsVariantMap = {
  "color": [
    "danger"
  ]
}

const comboboxOptionsVariantKeys = Object.keys(comboboxOptionsVariantMap)

export const comboboxOptions = /* @__PURE__ */ Object.assign(memo(comboboxOptionsFn.recipeFn), {
  __recipe__: true,
  __name__: 'comboboxOptions',
  __getCompoundVariantCss__: comboboxOptionsFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: comboboxOptionsVariantKeys,
  variantMap: comboboxOptionsVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, comboboxOptionsVariantKeys)
  },
  getVariantProps: comboboxOptionsFn.getVariantProps,
})